import React, { useEffect } from 'react'
import AddSkuNew from './AddSkuNew'
import PageLoader from 'Components/PageLoader'
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSKUDetail } from 'services/skus';
import toast from 'react-hot-toast';

const EditSkuNew = () => {
    const {id} = useParams()
    const allStates = useSelector((state) => state);
        const adminLoggedIn = allStates.reducer1;
        const clientCode = adminLoggedIn.ClientCode;
    const {
        data: SKUDetail,
        isLoading,
        isError:SKUTIsError,
        error:SKUTError
      } = useQuery({
        queryKey: ["SKU/SKUById",id,clientCode],
        queryFn: fetchSKUDetail,
        refetchOnWindowFocus: false,
        
      });

      useEffect(()=>{
        if(SKUTIsError && SKUTError){
          toast.error(SKUTError?.message,{
            position:"top-center",
            duration:2000
          })
        }
      },[SKUTIsError,SKUTError])

      console.log(SKUDetail)
  return (
    <div>
        {isLoading && <PageLoader/>}
        {!isLoading && !SKUTIsError && (
        <AddSkuNew editStatus={true} editData={SKUDetail && !isLoading && SKUDetail} editId={id}/>
        )}
    </div>
  )
}

export default EditSkuNew
